export default __webpack_public_path__ + "static/media/PRISPEK.72ae4bef.png";